import request from '@/utils/request'

// v80welderList
export function v80welderList(param) {
    let data = param
    return request({
      url: `/v80/v80welder/v80welderList`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
    
  }

   // v80welderDetailList
   export function v80welderDetailList(param) {
    let data = param
    return request({
      url: `/v80/v80welder/v80welderDetailList`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

   // v80welderInfo
   export function v80welderInfo(param) {
    let data = param
    return request({
      url: `/v80/v80welder/v80welderInfo`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  export function getBlobToImg(param) {
    let data = param
    return request({
        url: `/v80/v80welder/getBlobToImg`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
  }  